import DocumentTitle from 'react-document-title';

import Layout from 'hb-react/frontoffice/apps/Mentoring/components/Layout';
import NotFound from 'hb-react/frontoffice/apps/Mentoring/components/NotFound';
import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import { getPageTitle } from 'hb-react/frontoffice/utils/page';

const PageNotFound = () => {
  const { currentNetwork } = useDefaultAppContexts();

  return (
    <>
      <DocumentTitle
        title={getPageTitle({
          title: s__('Mentoring|Page not found'),
          featureName: '',
          currentNetwork,
        })}
      />
      <Layout>
        <NotFound />
      </Layout>
    </>
  );
};

export default PageNotFound;
